module.exports = __webpack_public_path__ + "img/player-card-icon.57e944e9.svg";